<template>
  <el-form class="department-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <el-form-item prop="oneFlag">
      <template slot="label">数量</template>
      <div class="ref-one-flag-row">
        <el-radio-group v-model="control.oneFlag">
          <el-radio :label="true">单选</el-radio>
          <el-radio :label="false">多选</el-radio>
        </el-radio-group>
      </div>
    </el-form-item>
    <el-form-item prop="defaultVal">
      <template slot="label">
        默认值
      </template>
      <default-val-input
        ref="defaultVal"
        :key="control._cid"
        :cur-control="control"
        :sheet="sheet"
        :available-sheet-map="availableSheetMap"
        :value="control.defaultVal"
      ></default-val-input>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        描述
      </template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="required">
      <template slot="label">
        必填
      </template>
      <el-checkbox v-model="control.required" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">
        显示
      </template>
      <el-checkbox v-model="control.display" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="disabled">
      <template slot="label">
        不可编辑
      </template>
      <el-checkbox v-model="control.disabled"></el-checkbox>
    </el-form-item>
    <el-form-item prop="main">
      <template slot="label">
        标题
      </template>
      <el-checkbox v-model="control.main" @change="checkChange($event)"></el-checkbox>
    </el-form-item>
  </el-form>
</template>

<script>
import DefaultValInput from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/default-val-input"
export default {
  name: "department-control",
  components: { DefaultValInput },
  props: {
    control: Object,
    sheet: Object,
    availableSheetMap: Object
  },
  methods: {
    checkChange(value) {
      this.$emit("checkboxChange", "main", value)
    }
  }
}
</script>

<style lang="scss" scoped>
.department-control {
}
</style>
